<template>
  <div v-if="messages.length" class="position-fixed top-0 end-0 end-md-15px end-lg-30px w-100 mt-80px mt-lg-100px px-15px px-md-0 w-md-auto" style="z-index: 2000;">
    <div v-for="(message, key) in messages" class="toast w-100 w-md-350px show" role="alert" aria-live="polite" aria-atomic="true">
      <div class="toast-body text-white rounded" :class="{'bg-danger': message.error || false, 'bg-success': message.success || false}">
        <span v-if="message.isSave || false">
          Zmeny boli úspešne uložené
        </span>

        <span v-if="message.isDelete || false">
          Došlo k úspešnému odstráneniu
        </span>

        <span v-if="message.isError || false">
          Pri ukladaní došlo k chybe
        </span>

        <div class="mt-5px">
				<span class="text-white text-decoration-underline" data-bs-dismiss="toast" aria-label="Zavrieť hlášku" style="font-size: .875rem; cursor: pointer;" @click="$emit('clearMessages')">
					Zavrieť
				</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['clearMessages'],
  props: {
    messages: {
      type: Array,
      default: []
    }
  }
}
</script>
